import {Component, Injector} from "@angular/core";
import {LocationSearchModel} from "../location-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {LocationSearchPageComponent} from "../location-search-page/location-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";


@Component({
    selector: "wbo-location-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(LocationSearchModel),
        registerSearchControl(LocationMultiSelectSearchControlComponent)
    ]
})
export class LocationMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<LocationSearchModel> {
    constructor(model: LocationSearchModel, injector: Injector) {
        super(model, injector, "outletGroupId", "groupName");
        this.extendedSearchComponent = LocationSearchPageComponent;
    }
}
